import { render, staticRenderFns } from "./data-disposal-method-form.vue?vue&type=template&id=2017d119"
import script from "./data-disposal-method-form.vue?vue&type=script&lang=js"
export * from "./data-disposal-method-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports